import httpHelper from "@/helpers/httpHelper";
// action types
export const GET_DATA_TABLE = "getDateTable"; 

//mutation types
export const SET_DATA_TABLE = "setDateTable";

export default {
    state: {
        listData:[],
    },
    getters: {
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
        loadedListData(state) {
            return state.listData;
        },
       
    },
    actions: {
        /**
         * Set the create countMyPurcents
         * @param state
         * @param payload
         */
         [GET_DATA_TABLE](context,payload) {
            
            // return new Promise((resolve, reject) => {
                context.commit(SET_DATA_TABLE,payload)
                // resolve(response);
            // });
        },
    },
    mutations: {
        [SET_DATA_TABLE](state, payload) {
            state.listData =payload;
        },
        
    }
};